import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

export default function CreateUploadCustomer({
  showUpload,
  closeModal,
  refreshPage,
}) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);

  const resetForm = () => {
    setFile(null);
    setValidationError({});
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select a file to upload");
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post("/user/customer/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // If backend just returns { success, message }
      if (response.data.success) {
        toast.success(response.data.message || "Customers imported successfully");
        handleClose();
        refreshPage();
      } else {
        toast.error(response.data.message || "Failed to import customers");
      }

    } catch (error) {
      console.error(error);

      // Handle validation errors from Laravel
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        setValidationError(errors);

        if (errors.file) {
          toast.error(`File error: ${errors.file.join(", ")}`);
        } else {
          // Show any other validation error
          Object.values(errors).forEach((errArr) => {
            toast.error(errArr.join(", "));
          });
        }
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while uploading the file");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateCSP">
      <Modal show={showUpload} onHide={handleClose} dialogClassName="modal-md">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Customer Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlFile1">
              <div>
                <h6>Upload Excel Document</h6>
                <small className="text-muted">
                  Accepted formats: .xlsx, .xls (Max 2MB)
                </small>
              </div>
              <Form.Control
                type="file"
                name="file"
                onChange={handleFileChange}
                accept=".xlsx,.xls"
                isInvalid={!!validationError.file}
                disabled={isLoading}
              />
              <Form.Control.Feedback type="invalid">
                {validationError.file?.[0]}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="mt-3">
              <small className="text-muted">
                Required columns: first_name, last_name, email, phone, customer_code, country, state, city, company_name, contact_person_phone, company_email, company_country, company_state, company_city
                <br />
                Ensure phone numbers are formatted as text (use quotes or text formatting), and all required fields are filled.
              </small>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#c4281b", borderColor: "#c4281b" }}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Uploading..." : "Upload"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}